"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchemaInput = exports.SchemaInputInternal = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const core_1 = require("react-hook-schema/core");
// useFormにvalueを渡すと、valueが変更されたときに反映されるはずだが、実際には反映しない。
const SchemaInputInternal = ({ schemaComponents, data, readOnly, schema, onValueChange, }) => {
    const Field = (0, core_1.createSelector)(schemaComponents);
    if (schema.schemaType === "object") {
        const { control } = (0, react_hook_form_1.useForm)({
            values: data,
        });
        const value = (0, react_hook_form_1.useWatch)({ control });
        if (onValueChange) {
            (0, react_1.useEffect)(() => {
                if (data !== value) {
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(value);
                }
            }, [value]);
        }
        return react_1.default.createElement(Field, { control: control, schema: schema, readOnly: readOnly });
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { control, setValue } = (0, react_hook_form_1.useForm)({
            defaultValues: { default: data },
        });
        const value = (0, react_hook_form_1.useWatch)({ control });
        if (onValueChange) {
            (0, react_1.useEffect)(() => {
                if (data !== value.default) {
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(value.default);
                }
            }, [value.default]);
        }
        (0, react_1.useEffect)(() => {
            setValue("default", data);
        }, [data]);
        return (react_1.default.createElement(Field, { control: control, schema: {
                schemaType: "object",
                properties: [
                    {
                        title: "default",
                        propertyName: "default",
                        noLabel: true,
                        schema,
                    },
                ],
            }, readOnly: readOnly }));
    }
};
exports.SchemaInputInternal = SchemaInputInternal;
const createSchemaInput = (schemaComponents) => {
    return (props) => {
        return (react_1.default.createElement(exports.SchemaInputInternal, Object.assign({ schemaComponents: schemaComponents }, props)));
    };
};
exports.createSchemaInput = createSchemaInput;
